export default (breakPoint) => {
  const mediaQuery = matchMedia(`(min-width: ${breakPoint}px)`);
  let isMatch = mediaQuery.matches; // 初期値を設定
  // ページが読み込まれた時に実行
  handle(mediaQuery);
  // ウィンドウサイズが変更されても実行されるように
  mediaQuery.addEventListener('change', handle);
  function handle(mq) {
    isMatch = mq.matches; // 結果を更新
  }
  return () => isMatch; // 結果を取得するための関数を返す
};
